import {
  Button,
  Card,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "i18n/i18n";
import React, { useEffect, useRef, useState } from "react";
import { useBoundStore } from "store/store";
import CreatableSelect from "react-select/creatable";
import { v4 as uuidv4 } from "uuid";

import Axios from "apis/axios";

import "react-dropdown-tree-select/dist/styles.css";

import * as EmailValidator from "email-validator";

import moment from "moment";
import ScopeHeader from "components/ScopeHeader";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import AntDTree from "components/AntDTree";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ReactComponent as RoundedbackSvg } from "assets/Svgs/RoundedBack.svg";
import BadgeTabs from "components/BadgeTabs";

import { ReactComponent as FlashSvg } from "assets/Svgs/Flash.svg";
import { ReactComponent as FlashSvgWhite } from "assets/Svgs/FlashWhite.svg";

import { ReactComponent as BrokenClock } from "assets/Svgs/BrokenClock.svg";
import { ReactComponent as BrokenClockWhite } from "assets/Svgs/BrokenClockWhite.svg";

import { ReactComponent as FlickCursor } from "assets/Svgs/FlickCursor.svg";
import { ReactComponent as FlickCursorWhite } from "assets/Svgs/FlickCursorWhite.svg";

dayjs.extend(duration);

function NewReports() {
  const lang: any = useBoundStore((state) => state.lang);

  const location = useLocation();
  const reportData = location.state?.report;
  const isEditMode = location.state?.isEditMode;

  const getReportConfigProducts = useBoundStore(
    (state) => state.getReportConfigProducts
  );

  const reportConfigProducts: any = useBoundStore(
    (state) => state.reportConfigProducts
  );

  const reportConfigProductsLoader: any = useBoundStore(
    (state) => state.reportConfigProductsLoader
  );

  const navigate = useNavigate();
  const createReportConfig = useBoundStore((state) => state.createReportConfig);
  const updateReportConfig = useBoundStore((state) => state.updateReportConfig);
  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const legalEntityNodeId = useBoundStore((state) => state.legalEntityNodeId);
  const userNodeId = useBoundStore((state) => state.userNodeId);
  const [loading, setLoading] = useState(false);

  const [isSingleEquipment, setIsSingleEquipment] = useState(false);

  // activeId
  // 1. Time based
  // 2. Event Based
  // 3. Manuall Based

  const [activeId, setActiveId] = useState(
    location.state?.activeId ? +location.state?.activeId : 0
  );

  const [eventType, setEventType] = useState(
    isEditMode ? reportData?.reportconfiguration.triggeringevent : ""
  );

  const [product, setProduct] = useState<any>(
    isEditMode
      ? {
          label: reportData?.reportconfiguration.filterbyproduct,
          value: reportData?.reportconfiguration.filterbyproduct,
        }
      : ""
  );


  const [startTime, setStartTime] = React.useState(
    isEditMode
      ? reportData?.reportconfiguration.manualstarttimestamp
      : moment().unix() * 1000
  );

  const [endTime, setEndTime] = React.useState(
    isEditMode
      ? reportData?.reportconfiguration.manualendtimestamp
      : moment().unix() * 1000
  );

  let startTimeVar,
    endTimeVar = 0;
  const currentDate = new Date();
  endTimeVar = currentDate.getTime();
  const last24HoursDate = new Date(currentDate.getTime());

  startTimeVar = last24HoursDate.getTime();

  const [startDate, setStartDate] = React.useState(
    moment(isEditMode ? startTime : startTimeVar).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = React.useState(
    moment(isEditMode ? endTime : endTimeVar).format("YYYY-MM-DD")
  );

  const [factories, setFactories] = useState("");
  const [sendViaEmail, setSendViaEmail] = useState(true);

  const [treeValues, setTreeValues] = useState([""]);

  const [treeInitialValues, setTreeInitialValues] = useState<any>([]);

  const [sitesNodeIds, setSitesNodeIds] = useState<string[]>([]);
  const [areasNodeIds, setAreasNodeIds] = useState<string[]>([]);
  const [areas, setAreas] = useState("");
  const [devices, setDevices] = useState("");
  const [receiversEmail, setReceiversEmail] = useState("");

  const [selectedNodes, setSelectedNodes] = useState<any>([]);

  const [title, setTitle] = useState("");
  const [cycles, setCycles] = useState<string>("");
  const [exports, setExports] = useState("");
  const [time, setTime] = useState<any>(dayjs(new Date()));
  const [startingfrom, setStartingfrom] = useState<any>();

  const [timeRange, setTimeRange] = useState(
    isEditMode ? reportData?.reportconfiguration.manualinterval : ""
  );

  const [customTimeRange, setCustomTimeRange] = useState(
    isEditMode
      ? reportData?.reportconfiguration.manualinterval === "customInterval"
      : false
  );

  const [reportConfigurationNodeId, setReportConfigurationNodeId] =
    useState<string>("");

  const [equipmentsNodeIds, setEquipmentsNodeIds] = useState<string[]>([]);

  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e: any) => {
    const newEmail = e.target.value;
    setReceiversEmail(newEmail);

    // check for signle Email
    let isMultiple = newEmail.includes(";") && newEmail.split(";");
    if (isMultiple.length) {
      isMultiple.map((email: string) => {
        setIsValidEmail(EmailValidator.validate(email));
      });
    } else {
      // Regular expression for basic email validation
      setIsValidEmail(EmailValidator.validate(newEmail));
    }
  };

  const handleFactoriesChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;
    if (selectedValue === "alle") {
      // Set factories to an array containing all the keys
      setSitesNodeIds(
        Object.keys(siteData).map((key) => siteData[key]?.nodeid)
      );
    } else {
      // Set factories to an array with the selected value
      setSitesNodeIds([selectedValue]);
    }
    setFactories(selectedValue);
  };

  const handleAreasChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;

    if (selectedValue === "alle") {
      // Set areasNodeIds to an array containing all the nodeids
      setAreasNodeIds(
        Object.keys(siteData).flatMap((key) =>
          siteData[key]?.hasarea.map((area) => area?.area?.nodeid)
        )
      );
    } else {
      // Set areasNodeIds to an array with the selected value
      setAreasNodeIds([selectedValue]);
    }
    setAreas(selectedValue);
  };

  const handleDevicesChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;

    if (selectedValue === "alle") {
      const allNodeIds: string[] = [];
      Object.keys(siteData).forEach((key) => {
        siteData[key].hasarea.forEach((area: any) => {
          area.area.hasequipment.forEach((equipment: any) => {
            allNodeIds.push(equipment.equipment.nodeid);
          });
        });
      });
      setEquipmentsNodeIds(allNodeIds);
    } else {
      setEquipmentsNodeIds([selectedValue]);
    }

    setDevices(selectedValue);
  };

  const handleCyclesChange = (event: SelectChangeEvent) => {
    setDays("");
    setCycles(event.target.value as string);
  };

  const handleDaysChange = (event: SelectChangeEvent) => {
    setDays(event.target.value as string);
  };
  const getCurrentMonth = () => {
    const currentDate = new Date();
    const month = currentDate.toLocaleString("en-US", { month: "long" });
    return month;
  };
  const getCurrentDay = () => {
    const currentDay = new Date().getDate();
    return currentDay.toString();
  };

  const getCurrentDaysOfWeek = () => {
    const dayNames = i18n(lang).days_list;
    const todayIndex = new Date().getDay();
    const rotatedDayNames = [
      ...dayNames.slice(todayIndex),
      ...dayNames.slice(0, todayIndex),
    ];
    return rotatedDayNames || [];
  };
  const getCurrentDaysOfMonth = () => {
    const daysOfMonth = Array.from({ length: 28 }, (_, i) =>
      (i + 1).toString()
    );
    return daysOfMonth || [];
  };

  const [days, setDays] = useState<string>(""); // Set the default value to the current day
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const handleTimeRangeChange = (event: any) => {
    if (event.target.value === "customInterval" && activeId === 2) {
      setCustomTimeRange(true);
    } else {
      setCustomTimeRange(false);
    }
    setTimeRange(event.target.value);
    setProduct({ label: "", value: "" });
  };

  


  function getNextTimestamp(zyklus:any, tag:any, uhrzeitTimestamp:any) {

    const now = dayjs();
    const uhrzeit = dayjs(uhrzeitTimestamp); // Convert timestamp to dayjs object
    let nextDate;
  
    if (zyklus === "1m") {
      // Monthly: Use the selected day, merge with uhrzeit
      let selectedDate = now.date(tag).hour(uhrzeit.hour()).minute(uhrzeit.minute()).second(0);
  
      if (selectedDate.isBefore(now)) {
        selectedDate = selectedDate.add(1, "month");
      }
  
      nextDate = selectedDate;
  
    } else if (zyklus === "1w") {
      // Weekly: Convert weekday name to index
      const selectedWeekday = i18n(lang).days_list.indexOf(tag);
      let targetDay = now.day(selectedWeekday).hour(uhrzeit.hour()).minute(uhrzeit.minute()).second(0);
  
      if (targetDay.isBefore(now)) {
        targetDay = targetDay.add(1, "week");
      }
  
      nextDate = targetDay;
  
    } else if (zyklus === "1d") {
      // Daily: Just move to the next day with given time
      nextDate = now.hour(uhrzeit.hour()).minute(uhrzeit.minute()).second(0);

      if (nextDate.isBefore(now)) {
        nextDate = nextDate.add(1, "day");
      }

    }
    if(nextDate){
      return nextDate?.unix() * 1000;
    }
  
     // Convert to milliseconds
  }

  useEffect(() => {
    let getTimeStamp = getNextTimestamp(cycles, days,time);
    
    setStartingfrom(getTimeStamp);
  }, [days, time,cycles]);

  useEffect(() => {
    setTreeInitialValues([]);
    setProduct({ label: "", value: "" });

    setExports(activeId === 1 ? "equipment" : "");
  }, [activeId]);

  let checkday = new Date();

  const repetions = [
    { key: i18n(lang).repition_monthly, value: "1m" },
    { key: i18n(lang).repition_weekly, value: "1w" },
    { key: i18n(lang).repition_daily, value: "1d" },
  ];

  const exportsettings = [
    { key: i18n(lang).exportsettings_site, value: "site" },
    { key: i18n(lang).exportsettings_area, value: "area" },
    { key: i18n(lang).exportsettings_equipment, value: "equipment" },
  ];

  const handleExportChange = (event: any) => {
    setExports(activeId === 1 ? "equipment" : (event.target.value as string));
  };

  const handleEventChange = (event: SelectChangeEvent) => {
    setEventType(event.target.value as string);
  };

  const handleProductChange = (event: any) => {
    setProduct(event);
  };

  interface reportObject {
    title: string;
    lang: string;
    allsites: boolean;
    startingfrom: number;
    repetitioninterval: string;
    exportsettings: string;
    legalEntityNodeId: string;
    userNodeId: string;
    areasNodeIds: string[];
    equipmentsNodeIds: string[];
    sitesNodeIds: string[];
    nodeid: string;
    reportConfigurationNodeId: string;
    emailrecipients: string;
    sendviaemail: boolean;
    isactive: boolean;
    triggertype: string;
    manualinterval?: string;
    manualstarttimestamp?: any;
    manualendtimestamp?: any;
    filterbyproduct?: string;
    triggeringevent?: string;
  }

  const handleAddReportConfig = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    setLoading(true);
    let treeData: any = makeSelectData(true, false);


    let obj: reportObject = {
      title: title,
      lang: lang,
      allsites: treeValues.includes("all"),
      startingfrom: startingfrom,
      repetitioninterval: cycles,
      exportsettings: exports,
      legalEntityNodeId: legalEntityNodeId,
      userNodeId: userNodeId,
      sitesNodeIds: treeData.selectedSitesNodeiDs,
      areasNodeIds: treeData.selectedAreasNodeiDs,
      equipmentsNodeIds: treeData.selectedEquipmentsNodeiDs,
      nodeid: "", // Add the appropriate value
      reportConfigurationNodeId: isEditMode ? reportConfigurationNodeId : "",
      emailrecipients: receiversEmail,
      sendviaemail: sendViaEmail,
      isactive: true,
      triggertype:
        activeId === 0 ? "time" : activeId === 1 ? "event" : "manual",
      filterbyproduct:
        activeId <= 1 || treeValues.length > 1 ? "" : product.label,
    };

    if (activeId === 2) {
      obj.manualinterval = timeRange;
      obj.manualstarttimestamp = customTimeRange ? startTime : 0;
      obj.manualendtimestamp = customTimeRange ? endTime : 0;
    }

    if (activeId === 1) {
      obj.triggeringevent = eventType;
    }

    if (isEditMode) {
      try {
        const promises = await updateReportConfig(obj);

        if (isAuthUser === true) {
          const result = await Promise.all(promises);
          navigate(activeId === 2 ? "/manual-reports" : "/reports", {
            replace: true,
          });
        }
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    } else {
      console.log("Creating report with config:", obj);
      const promises = await createReportConfig(obj);
      if (isAuthUser === true) {
        try {
          const result = await Promise.all(promises);
          navigate(activeId === 2 ? "/manual-reports" : "/reports", {
            replace: true,
          });
        } catch (error) {
          console.error("Error during promise execution:", error);
        }
      }
    }

    setLoading(false);
  };

  interface SiteData {
    [siteId: string]: {
      name: string;
      nodeid: string;
      hasarea: Array<{ area: Record<string, any> }>;
    };
  }

  const siteData: SiteData = useBoundStore((state) => state.subscribedSites);

  let equipments: any = [];

  Object.entries(siteData).map((obj) => {
    obj[1] &&
      obj[1]?.hasarea &&
      obj[1]?.hasarea.map((area) => {
        if (area.area.nodeid === areas) {
          equipments.push(area.area.hasequipment);
        }
      });
  });

  useEffect(() => {
    if (reportData && isEditMode) {
      setTitle(
        reportData?.reportconfiguration?.title[lang]
          ? reportData?.reportconfiguration?.title[lang]
          : reportData?.reportconfiguration?.title
      );

      let emails = reportData?.reportconfiguration?.emailrecipients;
      setSendViaEmail(reportData?.reportconfiguration?.sendviaemail);
      setReceiversEmail(emails);

      setCycles(
        reportData?.reportconfiguration?.repetitioninterval
          ? reportData?.reportconfiguration?.repetitioninterval
          : ""
      );

      let tempInitialValues = [];

      if (reportData?.reportconfiguration?.hassite) {
        tempInitialValues.push(
          ...reportData?.reportconfiguration?.hassite.map((site: any) => {
            return site.site.nodeid;
          })
        );
      }

      if (reportData?.reportconfiguration?.hasarea) {
        tempInitialValues.push(
          ...reportData?.reportconfiguration?.hasarea.map((area: any) => {
            return area.area.nodeid;
          })
        );
      }

      if (reportData?.reportconfiguration?.hasequipment) {
        tempInitialValues.push(
          ...reportData?.reportconfiguration?.hasequipment.map((eq: any) => {
            return eq.equipment.nodeid;
          })
        );
      }
      if (reportData?.reportconfiguration?.allsites) {
        tempInitialValues = ["all", ...makeSelectData(false, true)];
      }

      setTreeInitialValues(tempInitialValues);

      setReportConfigurationNodeId(reportData?.reportconfiguration?.nodeid);

      setExports(reportData?.reportconfiguration?.exportsettings);

      if (reportData?.reportconfiguration?.repetitioninterval == "1d") {
        if (reportData?.reportconfiguration?.startingfrom) {
          let n_date = reportData?.reportconfiguration?.startingfrom;
          const date = new Date(n_date);
          let days = date.getDate().toString();
          setDays(days);

          //format Time
          const year = date.getUTCFullYear();
          const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
          const day = date.getUTCDate().toString().padStart(2, "0");
          const hours = date.getUTCHours().toString().padStart(2, "0");
          const minutes = date.getUTCMinutes().toString().padStart(2, "0");
          const seconds = date.getUTCSeconds().toString().padStart(2, "0");
          const milliseconds = date
            .getUTCMilliseconds()
            .toString()
            .padStart(3, "0");

          const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
          const timeAsDayjs = dayjs(new Date(formattedDateString));
          setTime(timeAsDayjs);
        }
      }

      if (reportData?.reportconfiguration?.repetitioninterval == "1w") {
        if (reportData?.reportconfiguration?.startingfrom) {
          let n_date = reportData?.reportconfiguration?.startingfrom;
          const date = new Date(n_date);
          const dayIndex = date.getDay();
          const dayNames = i18n(lang).days_list;
          const dayName = dayNames[dayIndex];
          setDays(dayName);

          //format Time
          const year = date.getUTCFullYear();
          const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
          const day = date.getUTCDate().toString().padStart(2, "0");
          const hours = date.getUTCHours().toString().padStart(2, "0");
          const minutes = date.getUTCMinutes().toString().padStart(2, "0");
          const seconds = date.getUTCSeconds().toString().padStart(2, "0");
          const milliseconds = date
            .getUTCMilliseconds()
            .toString()
            .padStart(3, "0");

          const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
          const timeAsDayjs = dayjs(new Date(formattedDateString));
          setTime(timeAsDayjs);
        }
      }
      if (reportData?.reportconfiguration?.repetitioninterval == "1m") {
        if (reportData?.reportconfiguration?.startingfrom) {
          let n_date = reportData?.reportconfiguration?.startingfrom;
          const date = new Date(n_date);
          const dayOfMonth = date.getDate().toString(); // Get the current day of the month
          const daysOfMonthArray = getCurrentDaysOfMonth();

          if (daysOfMonthArray.length === 28) {
            setDays(dayOfMonth);
          } else {
            // Handle case when the current day is not within the range of days in the month
            // For example, you might set a default value or handle it based on your requirement
          }

          //format Time
          const year = date.getUTCFullYear();
          const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
          const day = date.getUTCDate().toString().padStart(2, "0");
          const hours = date.getUTCHours().toString().padStart(2, "0");
          const minutes = date.getUTCMinutes().toString().padStart(2, "0");
          const seconds = date.getUTCSeconds().toString().padStart(2, "0");
          const milliseconds = date
            .getUTCMilliseconds()
            .toString()
            .padStart(3, "0");

          const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
          const timeAsDayjs = dayjs(new Date(formattedDateString));
          setTime(timeAsDayjs);
        }
      }
      if (reportData?.reportconfiguration?.allsites) {
        setFactories("alle");
        setAreas("alle");
        setDevices("alle");
      }
      //Filtering Sites
      if (reportData?.reportconfiguration?.hassite) {
        let defaultSites: any[] = [];
        Object.keys(siteData).forEach((key) => {
          if (siteData[key] && reportData?.reportconfiguration?.hassite) {
            reportData?.reportconfiguration?.hassite.forEach((element: any) => {
              if (siteData[key]?.nodeid === element?.site.nodeid) {
                defaultSites.push(siteData[key].nodeid);
              }
            });
          }
        });
        if (defaultSites.length < 2) {
          setSitesNodeIds(defaultSites);
          setFactories(defaultSites[0]);
        } else {
          setSitesNodeIds(defaultSites);
          setFactories("alle"); // Set a default value
        }
      }

      //Filtering Areas
      if (reportData?.reportconfiguration?.hasarea) {
        let defaultArea: any[] = [];
        Object.keys(siteData).forEach((key) => {
          if (
            siteData[key]?.hasarea &&
            reportData?.reportconfiguration?.hasarea
          ) {
            siteData[key].hasarea.map((area) => {
              reportData?.reportconfiguration?.hasarea.forEach(
                (element: any) => {
                  if (area.area.nodeid === element.area?.nodeid) {
                    defaultArea.push(area.area.nodeid);
                  }
                }
              );
            });
          }
        });
        if (defaultArea.length < 2) {
          setAreasNodeIds(defaultArea);
          setAreas(defaultArea[0]);
        } else {
          setAreasNodeIds(defaultArea);
          setAreas("alle"); // Set a default value
        }
      }

      //Filtering Eq
      if (reportData?.reportconfiguration?.hasequipment) {
        let defaultEqs: any[] = [];
        Object.keys(siteData).forEach((key) => {
          if (
            siteData[key]?.hasarea &&
            reportData?.reportconfiguration?.hasequipment
          ) {
            siteData[key].hasarea.map((area) => {
              area.area.hasequipment &&
                area.area.hasequipment.map((eq: any) => {
                  reportData?.reportconfiguration?.hasequipment.forEach(
                    (element: any) => {
                      if (eq?.equipment.nodeid === element.equipment?.nodeid) {
                        defaultEqs.push(eq.equipment.nodeid);
                      }
                    }
                  );
                });
            });
          }
        });
        if (defaultEqs.length < 2) {
          setEquipmentsNodeIds(defaultEqs);
          setDevices(defaultEqs[0]);
        } else {
          setEquipmentsNodeIds(defaultEqs);
          setDevices("alle"); // Set a default value
        }
      }
    }

    setTimeout(() => {
      setProduct(product);
    }, 1000);
  }, [isEditMode]);

  let selectError =
    treeValues.length === 0 ||
    (activeId === 0
      ? cycles === "" || (cycles !== "1d" && days === "")
      : activeId === 1
      ? eventType === ""
      : activeId === 2
      ? timeRange === ""
      : false);

  const [selectedData, setSelectedData] = useState<any>([]);

  const onAction = (node: any, action: any) => {};
  const onNodeToggle = (currentNode: any) => {};

  function getDateByRepititionInterval(date: any, repetitioninterval: any) {
    let formattedDate;
    // Extract time part from the date
    const timePart = moment(date)
      .locale(lang === "en" ? "es" : "de")
      .format("HH:mm");
    const dayOfMonth = moment(date)
      .locale(lang === "en" ? "es" : "de")
      .format("DD"); // Extract day of month

    switch (repetitioninterval) {
      case "1w":
        // For weekly repetition, include the extracted time
        formattedDate = `${i18n(lang).repition_weekly} (${
          cycles === "1w"
            ? days.split("").splice(0, 3).join("")
            : moment(date)
                .locale(lang === "en" ? "es" : "de")
                .format("dd")
        }), ${timePart} Uhr`;
        break;
      case "1d":
        // For daily repetition, include the extracted time
        formattedDate = `${i18n(lang).repition_daily}, ${timePart} Uhr`;
        break;
      case "1m":
        // For monthly repetition, add 1 month to the date
        // Note: This will not change the time, so if you want to format it differently, adjust here
        formattedDate = `${i18n(lang).repition_monthly} (${
          cycles === "1d" ? dayOfMonth : days
        }), ${timePart} Uhr`;

        break;
      default:
        // Default to just formatting the date if the interval isn't recognized
        formattedDate = moment(date)
          .locale(lang === "en" ? "es" : "de")
          .format("dddd, HH:mm");
    }

    return formattedDate;
  }

  // const MemoizedTreeSelect = React.memo(function MyComponent(props) {
  //   return (

  //   );
  // });

  interface TreeNode {
    id: string;
    title: string;
    children?: TreeNode[];
  }

  // const data: TreeNode[] = [
  //   { id: "1", title: "Parent 1", children: [{ id: "2", title: "Child 1" }] },
  //   { id: "3", title: "Parent 2", children: [{ id: "4", title: "Child 2" }] },
  // ];

  const makeSelectData = (
    getDataForPayload: boolean,
    allSitesNodeIds: boolean
  ) => {

    // console.log(treeValues,"treeValues")

    let selectedAreasNodeiDs: any = [];
    let selectedSitesNodeiDs: any = [];
    let selectedEquipmentsNodeiDs: any = [];

    let allNodeIdsforAlleState: any = [];

    let tempArray: any = [];
    Object.keys(siteData).map((key: any) => {
      if (getDataForPayload && treeValues.includes(siteData[key].nodeid)) {
        selectedSitesNodeiDs.push(siteData[key].nodeid);
      }
      allNodeIdsforAlleState.push(siteData[key].nodeid);

      tempArray.push({
        selectable: activeId !== 2,
        title: siteData[key].name,
        value: siteData[key].nodeid,
        key: siteData[key].nodeid,
        children: siteData[key].hasarea
          ? siteData[key].hasarea.map((hasarea: any) => {
              if (
                getDataForPayload &&
                treeValues.includes(hasarea.area.nodeid)
              ) {
                selectedAreasNodeiDs.push(hasarea.area.nodeid);
              }

              return {
                selectable: activeId !== 2,
                title: hasarea.area.name,
                key: hasarea.area.nodeid,
                value: hasarea.area.nodeid,
                children: hasarea.area?.hasequipment
                  ? hasarea.area?.hasequipment.map((hasequipment: any) => {
                      if (
                        getDataForPayload &&
                        treeValues.includes(hasequipment.equipment.nodeid)
                      ) {
                        selectedEquipmentsNodeiDs.push(
                          hasequipment.equipment.nodeid
                        );
                      }
                      return {
                        title: hasequipment.equipment.name,
                        key: hasequipment.equipment.nodeid,
                        value: hasequipment.equipment.nodeid,
                        children: [],
                      };
                    })
                  : [],
              };
            })
          : [],
      });
    });
    return getDataForPayload
      ? {
          selectedSitesNodeiDs: selectedSitesNodeiDs,
          selectedAreasNodeiDs: selectedAreasNodeiDs,
          selectedEquipmentsNodeiDs: selectedEquipmentsNodeiDs,
        }
      : allSitesNodeIds
      ? allNodeIdsforAlleState
      : [...tempArray];
  };



  const getTreeValues = (data: any) => {
    setTreeValues(data);
  };


  const handleStartTime = (event: React.ChangeEvent<HTMLInputElement>) => {
    
    // Fetch data or perform other actions based on startTime change
    
    const date = new Date(event.target.value);
    date.setHours(0, 0, 0, 0); // Set time to 00:01 AM
    const timestamp = date.getTime();
    setStartTime(+timestamp);

    setStartDate(event.target.value);
  };

  const handleEndTime = (event: any) => {
    const date = new Date(event.target.value);
    date.setHours(23, 59, 59, 999); // Set time to 00:01 AM
    const timestamp = date.getTime();
    
    setEndTime(timestamp);
    setEndDate(event.target.value);
  };

  const reportConfigProductsRef = useRef();

  useEffect(() => {
    if (
      startDate <= endDate ||
      (isEditMode && treeInitialValues.length === 1)
    ) {
      // proceed if there is valid time range
      callProducts(); // to call filter products API
    }
  }, [startDate, endDate, treeValues, isEditMode]);

  const checkForSingleEquipment = () => {
    // checking for existance of only single equipment in treeData
    let equipmentnodeid = "";
    let _treeData = makeSelectData(true, false);

    const {
      selectedSitesNodeiDs,
      selectedAreasNodeiDs,
      selectedEquipmentsNodeiDs,
    } = _treeData;


    if (
      selectedEquipmentsNodeiDs.length === 1 &&
      selectedSitesNodeiDs.length === 0 &&
      selectedAreasNodeiDs.length === 0
    ) {
      equipmentnodeid = selectedEquipmentsNodeiDs[0];
    } else if (selectedSitesNodeiDs.length === 1) {
      // or if there is site then select equipment of area that contains exactly one equipment
      Object.keys(siteData).map((key: any) => {
        let hasarea: any = siteData[key].hasarea ? siteData[key].hasarea : [];
        if (key === selectedSitesNodeiDs[0] && hasarea.length === 1) {
          if (
            hasarea.area?.hasequipment &&
            hasarea.area?.hasequipment.length === 1 &&
            equipmentnodeid === ""
          ) {
            equipmentnodeid = hasarea.area?.hasequipment[0].equipment.nodeid;
          }
        }
      });
    } else if (selectedAreasNodeiDs.length === 1) {
      Object.keys(siteData).map((key: any) => {
        // or if there is area then select equipment of first area
        siteData[key].hasarea &&
          siteData[key].hasarea.map((hasarea: any) => {
            if (
              hasarea.area?.nodeid === selectedAreasNodeiDs[0] &&
              hasarea.area?.hasequipment?.length === 1
            ) {
              equipmentnodeid = hasarea.area?.hasequipment[0].equipment.nodeid;
            }
          });
      });
    }

    return equipmentnodeid;
  };

  const callProducts = async () => {
    let singleEquipmentNodeid = checkForSingleEquipment();


    setIsSingleEquipment(singleEquipmentNodeid !== "");

    if (customTimeRange && singleEquipmentNodeid !== "") {
      getReportConfigProducts(
        startTime,
        endTime,
        singleEquipmentNodeid,
        legalEntityNodeId
      );
    }
  };

  const eventTypes: any = {
    onnewproduct: i18n(lang).event_select_1,
    onnewbatch: i18n(lang).event_select_2,
  };


  return (
    <>
      
      <ScopeHeader
        bgColor="#B21412"
        bgImage="images/scope_header.png"
        txtColor="#FFFFFF"
        title={
          isEditMode
            ? i18n(lang)?.scope_edit_report_plan
            : i18n(lang)?.scope_new_report_plan
        }
        description={i18n(lang)?.scope_new_report_desc}
      />
      <Card className="new-report">
      
        <div className="reportsHeader">
          <div className="title" style={{ marginBottom: "24px" }}>
            {isEditMode
              ? i18n(lang).report_edit
              : i18n(lang)?.new_report_title_1}
          </div>
        </div>
        <Grid container className="initialCard" sx={{ paddingTop: 0 }}>
          <Grid item xs={9}>
            <TextField
              id="outlined-helperText"
              label={i18n(lang)?.new_report_input_placeholder}
              defaultValue=""
              helperText={
                title === ""
                  ? i18n(lang)?.required_field
                  : i18n(lang)?.new_report_input_subheader_1
              }
              fullWidth
              error={title === ""}
              onChange={handleTitleChange}
              value={title}
            />
          </Grid>
        </Grid>
        <Divider
          orientation="horizontal"
          sx={{ margin: "36px 0px 24px 0px" }}
        />

        <div className="reportsHeader" style={{ paddingTop: 0 }}>
          <div className="title">{i18n(lang)?.type_of_report}</div>
          <div className="customBadgeTabsWrapper">
            <BadgeTabs
              content={[
                {
                  id: 0,
                  text: i18n(lang).time_based,
                  activeIcon: <BrokenClockWhite />,
                  inActiveIcon: <BrokenClock />,
                  disabled: isEditMode && activeId >= 1,
                },
                {
                  id: 1,
                  text: i18n(lang).event_based,
                  inActiveIcon: <FlashSvg />,
                  activeIcon: <FlashSvgWhite />,
                  disabled: isEditMode && (activeId == 0 || activeId == 2),
                },
                {
                  id: 2,
                  text: i18n(lang).manual,
                  inActiveIcon: <FlickCursor />,
                  activeIcon: <FlickCursorWhite />,
                  disabled: isEditMode && activeId <= 1,
                },
              ]}
              showDesc
              setActiveId={setActiveId}
              activeId={activeId}
            />
          </div>
        </div>

        {activeId === 0 ? (
          <Grid
            container
            spacing={3}
            
            sx={{ padding: "0% 3%" }}
          >
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.new_report_title_3_select_1_label}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select-1"
                  value={cycles}
                  label={i18n(lang)?.new_report_title_3_select_1_label}
                  onChange={handleCyclesChange}
                  error={cycles === ""}
                >
                  {repetions.length > 0 &&
                    repetions.map((x, key) => (
                      <MenuItem value={x.value}>{x.key}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.new_report_title_3_select_2_label}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select-2"
                  value={days}
                  label={i18n(lang)?.new_report_title_3_select_2_label}
                  onChange={handleDaysChange}
                  disabled={cycles === "1d" ? true : false}
                  error={days === ""}
                >
                  {cycles == "1m" ? (
                    getCurrentDaysOfMonth().map((month: any) => (
                      <MenuItem key={month} value={month}>
                        {month}
                      </MenuItem>
                    ))
                  ) : cycles == "1w" ? (
                    getCurrentDaysOfWeek().map((day: any) => (
                      <MenuItem key={day} value={day}>
                        {day}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={""} value={""}>
                      {""}
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={4}
              sx={{
                padding: "17px 0px 0px 24px !important",
                display: "flex",
                alignItems: "end",
              }}
            >
              <FormControl fullWidth>
                <div className="new_report_time">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimePicker"]}>
                      <DemoItem>
                        <TimePicker
                          value={time}
                          onChange={(newValue) => setTime(newValue)}
                          defaultValue={dayjs(new Date())}
                          label={i18n(lang).Uhrzeit}
                          views={["hours", "minutes"]}
                          ampm={false}
                        />
                      </DemoItem>
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
              </FormControl>
            </Grid>
          </Grid>
        ) : activeId === 1 ? (
          <Grid
            container
            spacing={3}
            className="initialCard"
            sx={{
              paddingTop: 0,
              display: "block",
              width: "100%",
              marginTop: "36px",
            }}
          >
            <Grid item xs={4} sx={{ display: "inline" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.event}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={eventType}
                  label={i18n(lang)?.event}
                  onChange={handleEventChange}
                  error={eventType === ""}
                >
                  <MenuItem value={"onnewproduct"}>
                    {i18n(lang).event_select_1}
                  </MenuItem>
                  <MenuItem value={"onnewbatch"}>
                    {i18n(lang).event_select_2}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            spacing={3}
            className="initialCard"
            sx={{
              paddingTop: 0,
              display: "block",
              width: "100%",
              marginTop: "36px",
            }}
          >
            <Grid item xs={4} sx={{ display: "inline" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.timerange}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={timeRange}
                  label={i18n(lang)?.timerange}
                  onChange={handleTimeRangeChange}
                  error={timeRange === ""}
                  fullWidth
                >
                  {Object.keys(i18n(lang).manualReportsSelectOptions).length
                    ? Object.keys(i18n(lang).manualReportsSelectOptions).map(
                        (item: any, index: number) => {
                          return (
                            <MenuItem
                              value={
                                i18n(lang).manualReportsSelectOptions[item]
                                  ?.value
                              }
                            >
                              {
                                i18n(lang).manualReportsSelectOptions[item]
                                  .label
                              }
                            </MenuItem>
                          );
                        }
                      )
                    : ""}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        )}

        <div>
          {customTimeRange && activeId === 2 ? (
            <Grid
              className=" initialCard"
              container
              spacing={3}
              sx={{
                paddingTop: 0,
                width: "100%",
                marginTop: "36px",
              }}
            >
              <Grid item xs={6}>
                <TextField
                  id="date"
                  label={i18n(lang)?.date_from}
                  type="date"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={startDate}
                  error={startDate > endDate}
                  onChange={handleStartTime}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  id="date"
                  label={i18n(lang)?.date_to}
                  type="date"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={startDate > endDate}
                  value={endDate}
                  onChange={handleEndTime}
                />
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </div>

        <div
          className="reportsHeader"
          style={{ paddingTop: 0, marginTop: "36px" }}
        >
          <div className="title">{i18n(lang)?.new_report_title_2}</div>
        </div>

        <AntDTree
          treeData={makeSelectData(false, false)}
          getTreeValues={getTreeValues}
          initialValues={treeInitialValues}
        />

       

        {activeId !== 0 ? (
          <Grid
            container
            spacing={3}
            className="initialCard"
            sx={{
              paddingTop: 0,
              display: "block",
              width: "100%",
              marginTop: "24px",
            }}
          >
            <Grid item xs={4} sx={{ display: "inline" }}>
              <FormControl fullWidth>
                   <InputLabel className="customMuiLabel" shrink>{i18n(lang).product}</InputLabel>
                <CreatableSelect
                  isLoading={reportConfigProductsLoader}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      height: "56px",
                      borderColor: "grey",
                    }),
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#38748d",
                    },
                  })}
                  value={product}
                  onChange={handleProductChange}
                  className="reportConfigProducts"
                  isClearable
                  isDisabled={
                    activeId === 1 || !customTimeRange || !isSingleEquipment
                  }

                  placeholder="---Select---"
                  options={reportConfigProducts.map((product: any) => {
                    return { value: product, label: product };
                  })}
                />
              </FormControl>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        <div className="reportsHeader" style={{ padding: "36px 0px 0px 24px" }}>
          <div className="title">{i18n(lang)?.new_report_title_4}</div>
        </div>
        <Grid
          container
          spacing={3}
          className="initialCard"
          sx={{ paddingTop: 0 }}
        >
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                {i18n(lang)?.new_report_title_4_select_1_label}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={exports}
                label={i18n(lang)?.new_report_title_4_select_1_label}
                onChange={handleExportChange}
                disabled={activeId === 1}
                error={exports === ""}
              >
                <MenuItem value={"all"}>{i18n(lang).all}</MenuItem>

                {exportsettings.length > 0 &&
                  exportsettings.map((x, key) => (
                    <MenuItem
                      value={x.value}
                      selected={x.value === "equipment"}
                    >
                      {x.key}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={7} sx={{ padding: 0 }}>
            <div
              className="secondaryTitleNormal"
              style={{ paddingTop: "15px" }}
            >
              {exports == "site"
                ? i18n(lang)?.new_report_input_subheader_2_site
                : exports == "area"
                ? i18n(lang)?.new_report_input_subheader_2_area
                : exports == "equipment"
                ? i18n(lang)?.new_report_input_subheader_2_equipment
                : exports == "all"
                ? i18n(lang)?.new_report_input_subheader_2_all
                : i18n(lang)?.new_report_input_subheader_2}
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className="initialCard"
          sx={{ paddingTop: 0, paddingLeft: 0 }}
        >
          <Grid item xs={4}>
            <FormGroup
              className="initialCard report_checkbox"
              sx={{ marginBottom: "36px", width: "100%" }}
            >
              <FormControlLabel
                sx={{
                  width: "100%",
                }}
                control={
                  <Checkbox
                    value={sendViaEmail}
                    checked={sendViaEmail}
                    onChange={() => {
                      setSendViaEmail(!sendViaEmail);
                    }}
                    sx={{ color: "var(--primarys-color)" }}
                  />
                }
                label={i18n(lang)?.new_report_checkbox_label}
              />
            </FormGroup>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className="initialCard"
          sx={{ paddingTop: 0 }}
        >
          <Grid item xs={4} style={{ paddingTop: "0px" }}>
            {sendViaEmail ? (
              <>
                <TextField
                  sx={{ marginBottom: "5%" }}
                  id="outlined-helperText"
                  label={i18n(lang)?.receivers_email}
                  defaultValue=""
                  placeholder="email;email;email..."
                  fullWidth
                  onChange={handleEmailChange}
                  value={receiversEmail}
                  error={!isValidEmail || receiversEmail === ""}
                />
              </>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Divider orientation="horizontal" />
        <div className="newReportsFooter">
          <div>
            <Button
              variant="contained"
              className="loginBtn lp125"
              disabled={
                title === "" ||
                exports === "" ||
                (activeId === 2 && customTimeRange && startDate > endDate) ||
                selectError ||
                (sendViaEmail && receiversEmail === "") ||
                (sendViaEmail && !isValidEmail)
              }
              onClick={(e) => handleAddReportConfig(e)}
              sx={{
                backgroundColor: "var(--primary-color)",
                margin: "24px 24px 24px 24px !important",
              }}
            >
              {i18n(lang)?.save}
            </Button>
          </div>
          <div className="secondaryTitleNormal">
            {i18n(lang).next_report + ": "}
            {activeId === 0
              ? ` ${getDateByRepititionInterval(startingfrom, cycles)} `
              : activeId === 1
              ? eventTypes[eventType]
              : activeId === 2
              ? i18n(lang).manual
              : ""}
          </div>
        </div>
      </Card>
    </>
  );
}

export default NewReports;
